// extracted by mini-css-extract-plugin
module.exports = {"listSend":"listSend--1Wb4o","btns":"btns--3HP0x","boxTitle":"boxTitle--3fotf","info":"info--2I4lY","high":"high--3aw7Z","code":"code--16ruJ","icons":"icons--QIEN0"};